import React from "react";
import { Bar } from "react-chartjs-2";


function LastCost() {
  const data = {
    labels: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
    
    datasets: [
      {
        label: "Spending",
        backgroundColor: "rgba(91,37,245, 0.2)",
        data: [500, 300, 800, 150, 200, 150, 800, 200, 800],
      },
      {
        label: "Arrival",
        backgroundColor: "rgba(91,37,245, 1)",
        data: [1000, 800, 1800, 1100, 1000, 800, 1800, 1600, 1800],
      },
    ],
  };

  const options = {
    cornerRadius: 0,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          fontColor: "rgba(0,0,0, 0.5)",
          boxWidth: 15,
          font: {
            size: 9,
          },
        },
      },
    },
    scales: {
      y: 
        {
          grid: {
            display: true,
            color: "rgba(91,37,245, 0.03)",
          },
          ticks: {
            maxTicksLimit: 5,
            font: {
                size: 9,
            }
          },
        },
      x: {
        ticks: {
            font: {
                size: 7,
            }
        }
       }
    },
  };

  return <Bar data={data} options={options}  />;
}

export default LastCost;
